<mat-card appearance="outlined">
  <mat-card-content>
    <h1 class="mat-headline-6">{{ 'NOTFOUND.TITLE' | translate }}</h1>
    <p class="">{{ 'NOTFOUND.MESSAGE' | translate }}</p>
  </mat-card-content>
</mat-card>
